import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export enum B2bProgramUnit {
    Each = 1,
    Lot = 2,
}

export const b2bProgramUnitList: AbstractListModel[] = [
    {
        id: B2bProgramUnit.Each,
        title: marker('b2b.data.unit-types.each'),
    },
    {
        id:  B2bProgramUnit.Lot,
        title: marker('b2b.data.unit-types.lot'),
    },
];
